var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-img',_vm._b({style:(_vm.isPlaceholder ? _vm.placeholderClass : ''),attrs:{"src":_vm.computedSrc,"alt":_vm.alt},on:{"error":_vm.handleLoadingError}},'b-img',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }